import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '../../i18n';
import '../../styles/fonts.css';
import '../../styles/tokens.css';
import '../../styles/base.css';
import '../common/common.css';
import './shell.css';
import '../../styles/teletext.css';
import App from './App';

// Mounts the new UI into the given element.
export default function mountNewUi(container: HTMLElement): void {
    createRoot(container).render(
        <StrictMode>
            <App />
        </StrictMode>,
    );
}
